module.exports = __webpack_public_path__ + "static/stork-photo-3-3c70fe27b668d26db157ad102a77eea1.jpg";